import { fontWeights, Heading3, Paragraph } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { useCheckOverflow } from '@va/util/hooks';
import classNames from 'classnames';
import { useRef } from 'react';

export const SettingsHeading = ({
  title,
  tooltip,
  subText,
}: {
  title: string | React.ReactNode;
  subText?: string;
  tooltip?: string | React.ReactNode;
}) => {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const isHeadingOverflow = useCheckOverflow(headingRef);

  return (
    <div className='flex flex-col items-start'>
      <TooltipWrapper
        disabled={!tooltip}
        interactive
        content={
          <div className='flex flex-col'>
            <div className={classNames('mb-2', { hidden: !isHeadingOverflow })}>{title}</div>
            <div>{tooltip}</div>
          </div>
        }
        ref={headingRef}
        trigger='click'
      >
        <div>
          <Heading3
            weight={fontWeights.semibold}
            className={classNames('truncate inline-block w-fit', {
              'border-b border-dashed border-gray-silver cursor-default': tooltip,
            })}
          >
            {title}
          </Heading3>
        </div>
      </TooltipWrapper>
      {subText && <Paragraph className='mt-1.5'>{subText}</Paragraph>}
    </div>
  );
};
